var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.loading)?_c(_setup.LoadingSpinner):_c(_setup.PostSigning,{attrs:{"heading":_vm.$t('widgetSigned.needToVerify'),"messageIntro":_vm.$t('widgetSigned.needToVerifyMessageIntro'),"message":_vm.$t('widgetSigned.needToVerifyMessage'),"type":"warning"}})
}
var staticRenderFns = []

export { render, staticRenderFns }